import React from 'react';
import moment from 'moment';

import styles from './workExperienceStyles';

import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';

import { employerUrl } from 'buyside/util/urlHelper';

const WorkExperience = ({ userProfile }) => {
  const experienceByFirmType = JSON.parse(userProfile.experienceByFirmType); // employerHistories
  const formatDate = dateString => moment(dateString).format('MMMM YYYY');
  return (
    <div>
      {experienceByFirmType && (
        <div className={styles.workExperienceSection}>
          <h4>Experience by Firm Type</h4>
          <ul className={styles.firmTypeExperienceList}>
            {Object.keys(experienceByFirmType).map((firmType, idx) => {
              const yearsExperience = experienceByFirmType[firmType];
              return (
                <li key={idx}>
                  <h4>{firmType}</h4>
                  <div>
                    {yearsExperience || '< 1'} year{yearsExperience <= 1 ? '' : 's'} experience
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className={styles.workExperienceSection}>
        <h4>Employment History</h4>
        <ul className={styles.employmentHistoryList}>
          {userProfile.employerHistories.map((employerHistory, idx) => {
            const {
              employer: { id: employerId, name, aumRange, fundType },
              title,
              currentEmployer,
              fromDate,
              toDate
            } = employerHistory;
            return (
              <li key={idx}>
                <h4>
                  <Link to={employerUrl(employerId)} type={LINK_TYPES.PLAIN}>
                    {name}
                  </Link>
                </h4>
                {fundType && (
                  <h5 className={styles.employmentHistoryFundType}>
                    {aumRange !== 'N/A' ? `${aumRange} ` : ''}
                    {fundType}
                  </h5>
                )}
                <div>{title}</div>
                {fromDate && (currentEmployer || toDate) && (
                  <div>
                    {formatDate(fromDate)} – {currentEmployer ? 'Present' : formatDate(toDate)}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default WorkExperience;
